import * as React from 'react';

import TransactionForm from 'components/forms/TransactionForm';
import ContentWrapper from 'components/ContentWrapper';

const AdjustingTransactionCreateScreen = () => (
  <ContentWrapper>
    <TransactionForm transactionType="adjusting" />
  </ContentWrapper>
);

export default AdjustingTransactionCreateScreen;
